import { makeStyles } from "@material-ui/core/styles";

/**
 * [ANTIGRAVITY] Sistema de Estilos Estándar de Botones BotMix
 * Inspirado en el diseño neón/transparente de Filtros Avanzados (TicketsManagerTabs)
 */
export const getStandardButtonStyles = (theme) => ({
  // 1. Botón de Acción Principal (Aplicar, Filtrar, Guardar, Actualizar)
  applyButton: {
    height: 36,
    borderRadius: 8,
    fontWeight: 600,
    fontSize: "0.82rem",
    textTransform: "none",
    padding: "6px 18px",
    backgroundColor: `${theme.palette.primary.main}1A`,
    border: `1px solid ${theme.palette.primary.main}80`,
    color: theme.palette.type === "dark" ? "#FFFFFF" : theme.palette.primary.main,
    boxShadow: `0 0 8px ${theme.palette.primary.main}26`,
    transition: "all 0.2s ease",
    display: "inline-flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: `${theme.palette.primary.main}2E`,
      border: `1.5px solid ${theme.palette.primary.main}`,
      boxShadow: `0 0 14px ${theme.palette.primary.main}80`,
      color: theme.palette.type === "dark" ? "#FFFFFF" : theme.palette.primary.main,
    },
    "&.Mui-disabled": {
      opacity: 0.5,
      color: theme.palette.text.disabled,
      borderColor: theme.palette.divider,
      backgroundColor: "transparent",
      boxShadow: "none",
    },
  },

  // 2. Botón Secundario (Cerrar, Cancelar, Volver)
  secondaryButton: {
    height: 36,
    borderRadius: 8,
    fontSize: "0.82rem",
    fontWeight: 600,
    textTransform: "none",
    padding: "6px 16px",
    color: theme.palette.type === "dark" ? "#94A3B8" : "#64748B",
    border: theme.palette.type === "dark" ? "1px solid rgba(255, 255, 255, 0.2)" : "1px solid #CBD5E1",
    backgroundColor: theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.04)" : "rgba(0, 0, 0, 0.03)",
    transition: "all 0.2s ease",
    display: "inline-flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.06)",
      color: theme.palette.type === "dark" ? "#FFFFFF" : "#0F172A",
    },
    "&.Mui-disabled": {
      opacity: 0.5,
      color: theme.palette.text.disabled,
      borderColor: theme.palette.divider,
      backgroundColor: "transparent",
    },
  },

  // 3. Botón de Peligro / Reset (Limpiar Todo, Eliminar, Restablecer)
  dangerButton: {
    height: 36,
    borderRadius: 8,
    fontSize: "0.82rem",
    fontWeight: 600,
    textTransform: "none",
    padding: "6px 16px",
    color: "#ff5252",
    border: "1px solid rgba(255, 82, 82, 0.4)",
    backgroundColor: theme.palette.type === "dark" ? "rgba(255, 82, 82, 0.05)" : "rgba(255, 82, 82, 0.04)",
    boxShadow: "0 0 6px rgba(255, 82, 82, 0.15)",
    transition: "all 0.2s ease",
    display: "inline-flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "rgba(255, 82, 82, 0.15)",
      border: "1.5px solid #ff5252",
      boxShadow: "0 0 12px rgba(255, 82, 82, 0.4)",
      color: "#ff5252",
    },
    "&.Mui-disabled": {
      opacity: 0.5,
      color: theme.palette.text.disabled,
      borderColor: theme.palette.divider,
      backgroundColor: "transparent",
      boxShadow: "none",
    },
  },
});

export const useStandardButtonStyles = makeStyles((theme) => getStandardButtonStyles(theme));
